import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { api } from "@/lib/api";

export function useResetSourceFrames() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: async (sn: string) => {
			await api.post(`/api/districts/deployment_tool/sources/${sn}/reset/`);
		},
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: queryKeys.mediaTransmitters.all });
		},
	});
}

type ResetMeterFramesParams = { sn: string; serialNumbers: string[] };

export function useResetMeterFrames() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: async ({ sn, serialNumbers }: ResetMeterFramesParams) => {
			await api.post(
				`/api/districts/deployment_tool/sources/${sn}/meters/reset/`,
				{ serial_numbers: serialNumbers },
			);
		},
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: queryKeys.mediaTransmitters.all });
		},
	});
}
